import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Signed-in app routes. Waits for Firebase Auth to resolve so a restoring
 * session is not bounced to the marketing page, then sends logged-out
 * visitors to bare /welcome.
 */
export default function SignedInOnly({ children }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="page">
        <div className="empty-state-card">
          <h3>Loading...</h3>
          <p className="settings-description">Checking your session.</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
}
